/* eslint-disable no-nested-ternary */
import {
    Accordion,
    AccordionContent,
    AccordionTitle,
    Card,
    CardContent,
    Checkbox,
    Divider,
    Input,
    Table,
    Button,
    Modal,
    Form,
} from 'semantic-ui-react'
import {
    AppButton,
    AppPrimaryButton,
    SubmitCancelButtons,
    FormTextAreaFormField,
    FormTextFormField,
} from 'elements'
import {
    CaretDown,
    CaretUp,
    CheckCircle,
    Clock,
    XCircle,
    X,
    Plus,
    DotsThreeVertical,
    PencilSimple,
    Copy,
    FilePdf,
    Envelope,
    Trash,
    QrCode,
    ListChecks,
    ChatsCircle,
} from 'phosphor-react'
import {
    FlexColumn,
    FlexRow,
    FlexRowBetween,
    LoaderBar,
    PaginationComponent,
    // AppButtonPopup,
    FlexRowWrap,
    AppTable,
    FlexBox,
    AddToLibraryButton,
    SendEmailModal,
} from 'components'
import React, { useEffect, useMemo, useState, useRef } from 'react'
import { createPortal } from 'react-dom'
import styled from 'styled-components'
import { InspectionSectionList } from 'page-components'
import {
    GetTempleteDetails,
    GetPublicTempleteDetails,
    GetAuditById,
} from 'hooks'
import { DesktopMode, useTabletAndBelowMediaQuery } from 'layout'
import {
    CommonUtility,
    DateFormat,
    DateUtility,
    GroupService,
    TemplateService,
    FormErrorText,
    generateTemplatePDF,
    TemplateResponseType,
    getTemplatePermissions,
    SHOW_REPORT_APPROVAL_FLOW,
    canStartAuditsByRole,
    canManageDepartmentsByRole,
    isApprovalAdmin,
    isRoleModelOn,
} from 'utility'
import { BrowserUtility } from 'utility/browser-utility'
import { useNavigate } from 'react-router-dom'
import CapaModal from './capaModal'
import { AutoRulesButton } from 'page-components/auto-ticket-rules'
import { QrStickerModal } from './QrStickerModal'
import { CustomerService } from 'utility/services/customer'
import { AuthService } from 'utility/services/auth'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { useNotification } from 'hooks/toast'
import { useSubscriptionUsage } from 'context/subscription-usage'
import {
    isPlanLimitErrorCode,
    getPlanLimitCode,
} from 'utility/plan-limit-events'

const CustomerContainer = styled.div`
    height: 250px;
    overflow: auto;
`

const DescriptionText = styled.span`
    color: #6c757d;
`

const ReadMoreButton = styled.button`
    background: transparent;
    border: none;
    color: #2f2ccf;
    font-weight: 600;
    padding: 0;
    margin-left: 4px;
    cursor: pointer;
    text-decoration: none;
    &:hover {
        text-decoration: underline;
    }
`

const ActionDropdownContainer = styled.div`
    position: relative;
    display: inline-block;
`

const DropdownMenu = styled.div`
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    border: 1px solid #e8e9e9;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 200px;
    z-index: 1000;
    margin-top: 8px;
    padding: 4px 0;
`

const MenuItem = styled.div`
    padding: 12px 16px;
    cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
    display: flex;
    align-items: center;
    gap: 12px;
    transition: background-color 0.2s ease;
    font-size: 14px;
    color: ${props => {
        if (props.disabled) return '#999'
        return props.danger ? '#dc3545' : '#333'
    }};
    opacity: ${props => (props.disabled ? 0.5 : 1)};
    pointer-events: ${props => (props.disabled ? 'none' : 'auto')};

    &:hover {
        background-color: ${props =>
        props.disabled ? 'transparent' : '#f8f9fa'};
    }
`

// 2026-10-18 template list layout: grouped menu (Manage / Share / Delete)
const MenuGroupLabel = styled.div`
    padding: 8px 16px 4px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #5b6475;
`

const MenuDivider = styled.div`
    height: 1px;
    margin: 4px 8px;
    background: #eef1f6;
`

// Secondary action next to the primary one (white, outlined)
const OutlineButton = styled(AppButton)`
    &&& {
        background: #ffffff;
        color: #14181f;
        border: 1px solid #cfd5e3;
        box-shadow: none;
    }
    &&&:hover {
        background: #f4f6fa;
    }
`

// Template table: left-aligned, light borders, compact header. Scoped to this list only.
const TemplateTableShell = styled.div`
    /* no overflow: hidden here - it would clip the actions menu on the last rows;
       the corner cells are rounded instead */
    .ui.celled.table {
        border: 1px solid #e3e7ef;
        border-radius: 14px;
    }
    .ui.celled.table thead tr:first-child th:first-child {
        border-top-left-radius: 14px;
    }
    .ui.celled.table thead tr:first-child th:last-child {
        border-top-right-radius: 14px;
    }
    .ui.celled.table tbody tr:last-child td:first-child {
        border-bottom-left-radius: 14px;
    }
    .ui.celled.table tbody tr:last-child td:last-child {
        border-bottom-right-radius: 14px;
    }
    .ui.celled.table tr th,
    .ui.celled.table tr td {
        border-left: none;
        vertical-align: middle;
    }
    .ui.celled.table thead th {
        background: #f8f9fc;
        color: #5b6475;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        padding: 12px 16px;
    }
    .ui.celled.table tbody td {
        padding: 10px 16px;
        border-top: 1px solid #eef1f6;
    }
    .ui.celled.table tbody tr:hover {
        background: #fafbfd;
    }
`

const TemplateNameBar = styled.span`
    width: 6px;
    height: 32px;
    border-radius: 3px;
    flex: none;
`

const StatusPill = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 700;
    white-space: nowrap;
`

const CustomerSchema = yup.object().shape({
    customer_name: yup
        .string()
        .trim('Customer name does not allow spaces')
        .strict()
        .required('Customer Name is required'),
    Address: yup.string().trim(FormErrorText.SpacesNotAllowed).strict(),
    City: yup.string().trim(FormErrorText.SpacesNotAllowed).strict(),
    State: yup.string().trim(FormErrorText.SpacesNotAllowed).strict(),
    Zip: yup.string().trim(FormErrorText.SpacesNotAllowed).strict(),
    Email: yup
        .string()
        .email('Please enter a valid email address')
        .trim(FormErrorText.SpacesNotAllowed)
        .strict(),
    Phone: yup
        .string()
        .trim(FormErrorText.SpacesNotAllowed)
        .strict()
        .nullable(),
})

const NewCustomerModal = ({ open, onClose, onCustomerAdded }) => {
    const [loading, setLoading] = useState(false)
    const {
        control,
        handleSubmit,
        reset,
        setValue,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(CustomerSchema),
    })

    // Get user info from AuthService
    const user = AuthService.getUser()
    const companyId = user?.Companies?.[0]?.CompanyId || 1
    const createdBy = user?.unique_id || 1

    useEffect(() => {
        if (open) {
            reset({
                customer_name: '',
                Address: '',
                City: '',
                State: '',
                Zip: '',
                Email: '',
                Phone: '',
            })
        }
    }, [open, reset])

    const onSubmit = async formData => {
        setLoading(true)
        try {
            const payload = {
                ...formData,
                CustomerGroupId: 1, // Default group ID
                CompanyId: companyId,
                CreatedBy: createdBy,
            }
            await CustomerService.add(payload)
            await onCustomerAdded()
            onClose()
        } catch (error) {
            console.error('Failed to add customer:', error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal open={open} onClose={onClose} size="small" className="model">
            <Modal.Header>
                <FlexRowBetween>
                    <span>New Client/Site</span>
                    <X className="pointer" size={32} onClick={onClose} />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <Form noValidate>
                    <Form.Group widths="equal">
                        <FormTextFormField
                            control={control}
                            label="Customer Name"
                            name="customer_name"
                            placeholder="Customer Name"
                            errors={errors?.customer_name}
                            defaultValue=""
                        />
                        <FormTextFormField
                            control={control}
                            label="Email"
                            name="Email"
                            placeholder="Email"
                            errors={errors?.Email}
                            defaultValue=""
                        />
                        <FormTextFormField
                            control={control}
                            label="Phone"
                            name="Phone"
                            placeholder="Phone"
                            errors={errors?.Phone}
                            defaultValue=""
                            type="tel"
                            onKeyPress={e => {
                                // Prevent alphabetic characters from being entered
                                const char = String.fromCharCode(e.which)
                                if (!/[0-9+\-() ]/.test(char)) {
                                    e.preventDefault()
                                }
                            }}
                            onChange={value => {
                                // Filter out any alphabetic characters that might have been pasted
                                const filteredValue = value.replace(
                                    /[^0-9+\-() ]/g,
                                    '',
                                )
                                if (filteredValue !== value) {
                                    setValue('Phone', filteredValue, {
                                        shouldValidate: true,
                                    })
                                }
                            }}
                        />
                    </Form.Group>
                    <FormTextAreaFormField
                        control={control}
                        label="Address"
                        name="Address"
                        placeholder="Address"
                        errors={errors?.Address}
                        defaultValue=""
                        rows={5}
                    />
                    <Form.Group widths="equal">
                        <FormTextFormField
                            control={control}
                            label="City"
                            name="City"
                            placeholder="City"
                            errors={errors?.City}
                            defaultValue=""
                        />
                        <FormTextFormField
                            control={control}
                            label="State"
                            name="State"
                            placeholder="State"
                            errors={errors?.State}
                            defaultValue=""
                        />
                        <FormTextFormField
                            control={control}
                            label="Zip"
                            name="Zip"
                            placeholder="Zip"
                            errors={errors?.Zip}
                            defaultValue=""
                            type="number"
                        />
                    </Form.Group>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <SubmitCancelButtons
                    onSubmit={handleSubmit(onSubmit)}
                    loading={loading}
                    onCancel={onClose}
                />
            </Modal.Actions>
        </Modal>
    )
}

const CustomerCheckBox = ({ item, value, onChange }) => {
    return (
        <p
            onClick={() => onChange(item.unique_id)}
            className="d-flex align-items-center pointer"
        >
            <Checkbox
                checked={value}
                onChange={() => onChange(item.unique_id)}
            />
            <span className="ms-2"> {item.customer_name || item.Email}</span>
        </p>
    )
}

const CustomerList = ({
    customerList,
    selectedCustomer,
    setSelectedCustomer,
    onAddNewCustomer,
    showAddCustomer = true,
}) => {
    const [list, setList] = useState([])
    const [search, setSearch] = useState('')
    const [originalCustomerList, setOriginalCustomerList] = useState([])

    useEffect(() => {
        const updatedList = [...customerList]
        setList(updatedList)
        setOriginalCustomerList(updatedList)
    }, [customerList])

    const onSearch = e => {
        const searchValue = e.target.value.toLowerCase()
        setSearch(searchValue)
        if (!searchValue) {
            setList(originalCustomerList)
        } else {
            setList(
                originalCustomerList.filter(
                    ele =>
                        (ele.customer_name &&
                            ele.customer_name
                                .toLowerCase()
                                .includes(searchValue)) ||
                        (ele.Email &&
                            ele.Email.toLowerCase().includes(searchValue)),
                ),
            )
        }
    }
    const onSelect = id => {
        // Toggle selection: if the same customer is selected, deselect it
        if (selectedCustomer.includes(id)) {
            setSelectedCustomer([])
        } else {
            setSelectedCustomer([id])
        }
    }
    return (
        <div>
            <FlexColumn>
                <h4 className="my-0">Client / Site</h4>
                <Divider />
                <Input
                    onChange={onSearch}
                    value={search}
                    placeholder="Search Client/Site"
                    icon="search"
                    fluid
                />
                {showAddCustomer && (
                    <div style={{ marginTop: '8px' }}>
                        <AppPrimaryButton
                            size="mini"
                            onClick={onAddNewCustomer}
                            style={{
                                width: '100%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Plus size={16} style={{ marginRight: '4px' }} />
                            New Client/Site
                        </AppPrimaryButton>
                    </div>
                )}
                <CustomerContainer className="d-flex flex-column mt-3">
                    {list.map(ele => (
                        <CustomerCheckBox
                            key={ele.unique_id}
                            item={ele}
                            value={selectedCustomer.includes(ele.unique_id)}
                            onChange={onSelect}
                        />
                    ))}
                </CustomerContainer>
            </FlexColumn>
        </div>
    )
}

const parseTemplateMetadata = metadataJson => {
    if (!metadataJson) return null
    if (typeof metadataJson === 'object') return metadataJson

    try {
        return JSON.parse(metadataJson)
    } catch (error) {
        return null
    }
}

const getInspectionScheduleTimes = templateSetting => {
    const metadata = parseTemplateMetadata(templateSetting?.MetadataJson)
    const schedule =
        metadata?.inspectionSchedule ||
        metadata?.schedule ||
        metadata?.dailyInspectionSchedule ||
        metadata

    const times = Array.isArray(schedule?.times)
        ? schedule.times
        : Array.isArray(schedule?.slotTimes)
            ? schedule.slotTimes
            : Array.isArray(schedule?.inspectionTimes)
                ? schedule.inspectionTimes
                : []

    return times
        .map(time => {
            if (typeof time === 'string') return time
            if (typeof time?.scheduledTime === 'string') return time.scheduledTime
            if (typeof time?.time === 'string') return time.time
            return null
        })
        .filter(Boolean)
}

const shouldShowPastInspections = templateSetting =>
    templateSetting?.IsShowPastTemplates === true &&
    Number(templateSetting?.PastTemplateTimeHours) > 0

const PastInspectionsPanel = ({ loading, items, templateSetting }) => {
    const inspectionTimes = getInspectionScheduleTimes(templateSetting)
    const windowHours = Number(templateSetting?.PastTemplateTimeHours) || 0

    return (
        <div>
            {windowHours > 0 && (
                <DescriptionText style={{ display: 'block', marginBottom: '12px' }}>
                    Showing completed inspections from the last {windowHours}{' '}
                    hour{windowHours > 1 ? 's' : ''} at this location.
                </DescriptionText>
            )}
            {inspectionTimes.length > 0 && (
                <DescriptionText style={{ display: 'block', marginBottom: '12px' }}>
                    Configured times: {inspectionTimes.join(', ')}
                </DescriptionText>
            )}
            {loading ? (
                <LoaderBar content="Loading recent inspections..." />
            ) : Array.isArray(items) && items.length > 0 ? (
                <Table celled compact unstackable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>Inspection</Table.HeaderCell>
                            <Table.HeaderCell>Completed By</Table.HeaderCell>
                            <Table.HeaderCell>Completed On</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {items.map(inspection => (
                            <Table.Row
                                key={
                                    inspection.AuditUniqueId ||
                                    inspection.AuditId ||
                                    `${inspection.AuditName}-${inspection.CompletedOn}`
                                }
                            >
                                <Table.Cell>
                                    {inspection.AuditName || 'Inspection'}
                                </Table.Cell>
                                <Table.Cell>
                                    {inspection.CreatedByName || '-'}
                                </Table.Cell>
                                <Table.Cell>
                                    {inspection.CompletedOn
                                        ? DateUtility.dateToLocalISO(
                                              new Date(inspection.CompletedOn),
                                              DateFormat.dateTime,
                                          )
                                        : '-'}
                                </Table.Cell>
                            </Table.Row>
                        ))}
                    </Table.Body>
                </Table>
            ) : (
                <DescriptionText>
                    No completed inspections found for the selected client/site
                    in the configured time window.
                </DescriptionText>
            )}
        </div>
    )
}

const savedTemplateBackground = item => {
    const raw = String(
        item?.BackgroundColorCode || item?.backgroundColorCode || '',
    ).trim()
    if (!/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(raw)) return null
    if (/^#fff(?:fff)?$/i.test(raw)) return null
    return raw
}

const templateNameBackground = (item, colors) => {
    const saved = savedTemplateBackground(item)
    if (saved) return saved
    if (!colors || !item) return null
    const byId = colors[item.Id] ?? colors[String(item.Id)]
    if (byId) return byId
    const guid = String(item.TemplateId || '').toUpperCase()
    return colors[guid] || null
}

const TemplateNameLabel = ({ item, colors, children }) => {
    const backgroundColor = templateNameBackground(item, colors)
    if (!backgroundColor) return children
    return (
        <span
            style={{
                backgroundColor,
                color: '#111',
                display: 'inline-block',
                padding: '4px 12px',
                lineHeight: 1.35,
            }}
        >
            {children}
        </span>
    )
}

// Table name cell: left-aligned name with the template colour as a thin bar (neutral when none)
const TemplateNameCell = ({ item, colors }) => (
    <span className="d-flex align-items-center" style={{ gap: 12 }}>
        <TemplateNameBar
            aria-hidden="true"
            style={{ background: templateNameBackground(item, colors) || '#e3e7ef' }}
        />
        <span style={{ fontWeight: 600, color: '#14181f' }}>
            {item.TemplateName}
        </span>
    </span>
)

const TemplateCard = ({
    item,
    onRemove,
    startInspection,
    // customerList,
    handleSetCapa,
    onSendEmail,
    onClone,
    customerList,
    customerLoading,
    onAddNewCustomer,
    primaryButtonLabel = 'Start Inspection',
    templateNameColors,
}) => (
    <Card fluid>
        <CardContent>
            <FlexRowBetween>
                <h4 title={item.TemplateName} className="font-bold text-lg">
                    <TemplateNameLabel item={item} colors={templateNameColors}>
                        {CommonUtility.truncateString(item.TemplateName, 20)}
                    </TemplateNameLabel>
                </h4>
            </FlexRowBetween>
            <h5 className="mt-0 align-items-center d-flex">
                <Clock className="me-1" />
                {DateUtility.dateToLocalISO(
                    new Date(item.CreatedOn),
                    DateFormat.mmDD,
                )}
            </h5>
            <Card.Description className="mt-3">
                <FlexRowWrap className="justify-content-end">
                    <ActionBoxes
                        isMobile
                        startInspection={list => startInspection(item, list)}
                        item={item}
                        customerList={customerList}
                        customerLoading={customerLoading}
                        onRemove={() => onRemove(item)}
                        handleSetCapa={handleSetCapa}
                        onSendEmail={onSendEmail}
                        onClone={onClone}
                        onAddNewCustomer={onAddNewCustomer}
                        primaryButtonLabel={primaryButtonLabel}
                    />
                </FlexRowWrap>
            </Card.Description>
        </CardContent>
    </Card>
)

const TemplateDescription = ({ description }) => {
    const [expanded, setExpanded] = useState(false)

    if (!description || description === 'Description unavailable') {
        return <span style={{ color: '#6c757d' }}>Description unavailable</span>
    }

    const words = description.trim().split(/\s+/)
    const wordLimit = 15
    const shouldTruncate = words.length > wordLimit
    const truncatedText = shouldTruncate
        ? words.slice(0, wordLimit).join(' ')
        : description
    const fullText = description

    const handleToggle = e => {
        e.stopPropagation()
        setExpanded(!expanded)
    }

    return (
        <span>
            <DescriptionText>
                {expanded ? fullText : truncatedText}
            </DescriptionText>
            {shouldTruncate && (
                <>
                    <span>...</span>
                    <ReadMoreButton type="button" onClick={handleToggle}>
                        {expanded ? 'read less' : 'read more'}
                    </ReadMoreButton>
                </>
            )}
        </span>
    )
}

const PublicTemplateCard = ({ item, addToLibrary, processingTemplateId }) => {
    console.log(item)
    return (
        <Card fluid>
            <CardContent>
                <FlexRowBetween>
                    <h4 title={item.CustomerName}>
                        {CommonUtility.truncateString(item.TemplateName, 20)}
                    </h4>
                </FlexRowBetween>
                <h5 className="mt-0 align-items-center d-flex">
                    <Clock className="me-1" />
                    {DateUtility.dateToLocalISO(
                        new Date(item.CreatedOn),
                        DateFormat.mmDD,
                    )}
                </h5>
                <Card.Description className="mt-3">
                    <TemplateDescription
                        description={item.TemplateDescription}
                    />
                </Card.Description>
                <Card.Description className="mt-3">
                    <FlexRowWrap className="justify-content-end">
                        <PublicActionBoxes
                            isMobile
                            item={item}
                            addToLibrary={addToLibrary}
                            processingTemplateId={processingTemplateId}
                        />
                    </FlexRowWrap>
                </Card.Description>
            </CardContent>
        </Card>
    )
}
const QuetionBox = ({ item, onQuestionSelect }) => {
    const [select, setSelect] = useState(true)
    return (
        <Card
            className="w-100 mb-2 p-2 pointer"
            onClick={() => {
                setSelect(!select)
                onQuestionSelect(item, !select)
            }}
        >
            <FlexRow>
                <Checkbox className="me-2" checked={select} />
                <div dangerouslySetInnerHTML={{ __html: item.Question }} />
            </FlexRow>
        </Card>
    )
}

const SectionBox = ({ item, onQuestionSelect }) => {
    const [open, setOpen] = useState(false)
    const isMobile = useTabletAndBelowMediaQuery()
    const toggleSection = () => {
        setOpen(!open)
    }

    return (
        <Accordion fluid styled className="mt-4">
            <AccordionTitle
                active={open}
                index={item.SectionId}
                onClick={toggleSection}
                className="section-name"
            >
                <FlexRowBetween>
                    <FlexRow className="align-items-center">
                        <span onClick={() => setOpen(!open)}>
                            {item.SectionName}
                        </span>
                    </FlexRow>
                    <span>
                        {open ? <CaretDown size={20} /> : <CaretUp size={20} />}
                    </span>
                </FlexRowBetween>
            </AccordionTitle>
            <AccordionContent className="outer-box" active={open}>
                <Divider className="my-0 mb-3" />
                <CardContent className="row p-0 ">
                    {item?.Questions?.map(ele => (
                        <div
                            key={ele.Id}
                            className={`col-4 ${isMobile && 'col-12'}`}
                        >
                            <QuetionBox
                                section={item}
                                item={ele}
                                onQuestionSelect={onQuestionSelect}
                            />
                        </div>
                    ))}
                </CardContent>
            </AccordionContent>
        </Accordion>
    )
}

const TemplateDetailsWithSections = ({
    data,
    onQuestionSelect,
    loading,
    copyTemplate,
}) => {
    return (
        <td className="p-4" colSpan="4">
            {loading && <LoaderBar />}
            {data.Sections?.map(ele => (
                <div key={ele.SectionId} className="col-12">
                    <SectionBox
                        item={ele}
                        onQuestionSelect={onQuestionSelect}
                        copySection={copyTemplate?.Sections?.find(
                            item => item.SectionId === ele.SectionId,
                        )}
                    />
                </div>
            ))}
        </td>
    )
}
const RowCheckBox = ({
    item,
    onQuestionSelect,
    removeTemplate,
    copyTemplate,
    addTemplates,
}) => {
    const [checked, setChecked] = useState(Boolean(copyTemplate?.Id))
    const { data, loading } = GetTempleteDetails(
        checked ? item?.TemplateId : false,
    )
    useEffect(() => {
        if (checked && data?.Id) {
            addTemplates(data)
        }
    }, [checked, data])
    const toggleTemplate = () => {
        setChecked(!checked)
        if (checked) {
            removeTemplate(item.Id)
        }
    }
    return (
        <>
            <Table.Row onClick={toggleTemplate}>
                <Table.Cell className="pointer">
                    <Checkbox
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                    />
                </Table.Cell>
                <Table.Cell className="pointer">{item.TemplateName}</Table.Cell>
                <DesktopMode>
                    <Table.Cell textAlign="center">
                        {item.IsPublic ? (
                            <CheckCircle size={32} color="#3bb052" />
                        ) : (
                            <XCircle size={32} color="#e41146" />
                        )}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                        {item.IsDefault ? (
                            <CheckCircle size={32} color="#3bb052" />
                        ) : (
                            <XCircle size={32} color="#e41146" />
                        )}
                    </Table.Cell>
                </DesktopMode>
            </Table.Row>
            <Table.Row colSpan="4">
                {checked && (
                    <TemplateDetailsWithSections
                        loading={loading}
                        data={data}
                        onQuestionSelect={onQuestionSelect}
                        copyTemplate={copyTemplate}
                    />
                )}
            </Table.Row>
        </>
    )
}

const PublicRowCheckBox = ({
    item,
    onQuestionSelect,
    removeTemplate,
    copyTemplate,
    addTemplates,
}) => {
    const [checked, setChecked] = useState(Boolean(copyTemplate?.Id))
    const { data, loading } = GetPublicTempleteDetails(
        checked ? item?.TemplateId : false,
    )
    useEffect(() => {
        if (checked && data?.Id) {
            addTemplates(data)
        }
    }, [checked, data])
    const toggleTemplate = () => {
        setChecked(!checked)
        if (checked) {
            removeTemplate(item.Id)
        }
    }
    return (
        <>
            <Table.Row onClick={toggleTemplate}>
                <Table.Cell className="pointer">
                    <Checkbox
                        checked={checked}
                        onChange={() => setChecked(!checked)}
                    />
                </Table.Cell>
                <Table.Cell className="pointer">{item.TemplateName}</Table.Cell>
                <DesktopMode>
                    <Table.Cell textAlign="center">
                        {item.IsPublic ? (
                            <CheckCircle size={32} color="#3bb052" />
                        ) : (
                            <XCircle size={32} color="#e41146" />
                        )}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                        {item.IsDefault ? (
                            <CheckCircle size={32} color="#3bb052" />
                        ) : (
                            <XCircle size={32} color="#e41146" />
                        )}
                    </Table.Cell>
                </DesktopMode>
            </Table.Row>
            <Table.Row colSpan="4">
                {checked && (
                    <TemplateDetailsWithSections
                        loading={loading}
                        data={data}
                        onQuestionSelect={onQuestionSelect}
                        copyTemplate={copyTemplate}
                    />
                )}
            </Table.Row>
        </>
    )
}

const CloneTemplateModal = ({ open, onClose, onSubmit, template }) => {
    const [templateName, setTemplateName] = useState(
        template?.TemplateName || '',
    )
    const [loading, setLoading] = useState(false)
    const isMobile = useTabletAndBelowMediaQuery()

    useEffect(() => {
        if (template) {
            setTemplateName(template.TemplateName)
        }
    }, [template])

    const handleSubmit = async () => {
        if (!templateName.trim()) return
        setLoading(true)
        try {
            await onSubmit(
                template.TemplateId,
                templateName,
                template.CreatedBy,
            )
            onClose()
        } catch (error) {
            console.error('Failed to clone template:', error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <Modal open={open} onClose={onClose} size="tiny" className="model">
            <Modal.Header>
                <FlexRowBetween>
                    <span>Clone Template</span>
                    <X className="pointer" size={32} onClick={onClose} />
                </FlexRowBetween>
            </Modal.Header>
            <Modal.Content>
                <Form>
                    <Form.Field>
                        <label>Template Name</label>
                        <Input
                            placeholder="Enter new template name"
                            value={templateName}
                            onChange={(e, { value }) => setTemplateName(value)}
                        />
                    </Form.Field>
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <div className={isMobile ? 'mb-3' : ''}>
                    <SubmitCancelButtons
                        loading={loading}
                        onSubmit={handleSubmit}
                        onCancel={onClose}
                        hideCancel={false}
                        cancelText="Cancel"
                        className="mt-2"
                    />
                </div>
            </Modal.Actions>
        </Modal>
    )
}

const InspectionPreviewContent = ({ auditId }) => {
    const { data, loading, error } = GetAuditById(auditId)

    if (loading) {
        return <LoaderBar content="Loading inspection..." />
    }

    if (error || !data || !data.Sections) {
        return (
            <p style={{ color: '#999', textAlign: 'center', padding: '20px' }}>
                Failed to load inspection preview.
            </p>
        )
    }

    const readOnlySections =
        Array.isArray(data.Sections) && data.Sections.length
            ? data.Sections.map(section => ({
                ...section,
                IsImported: true,
                Questions: Array.isArray(section.Questions)
                    ? section.Questions.map(q => ({
                        ...q,
                        IsReadOnly: true,
                        IsImported: true,
                    }))
                    : section.Questions,
            }))
            : data.Sections

    return (
        <InspectionSectionList
            list={readOnlySections}
            loading={false}
            submit={() => { }}
            onAnswerChanged={() => { }}
            errors={{}}
            submitError=""
            // Important: no addMedia passed -> MediaTypeFilesBox treats this as read-only
            publicScreen={false}
            showActionButtons={false}
            onBack={() => { }}
            copySection={() => { }}
            removeSection={() => { }}
            templateList={[]}
            onTemplateAdd={() => { }}
            templateId={data.AuditTemplateId}
            commentList={[]}
            refetch={() => { }}
            isReopened={false}
            validateFormSync={null}
        />
    )
}

const ActionBoxes = ({
    startInspection,
    onRemove,
    item,
    customerList,
    customerLoading,
    // eslint-disable-next-line no-unused-vars
    handleSetCapa,
    onSendEmail,
    onClone,
    onAddNewCustomer,
    primaryButtonLabel = 'Start Inspection',
}) => {
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)
    const [selectedCustomer, setSelectedCustomer] = useState([])
    const [pdfLoading, setPdfLoading] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false)
    const [previewOpen, setPreviewOpen] = useState(false)
    const [previewData, setPreviewData] = useState(null)
    const [previewLoading, setPreviewLoading] = useState(false)
    const [previewAuditId, setPreviewAuditId] = useState(null)
    const [qrModalOpen, setQrModalOpen] = useState(false)
    const [qrCustomerId, setQrCustomerId] = useState(null)
    // 'inspection' | 'qr' — same Client/Site modal, different submit action
    const [modalPurpose, setModalPurpose] = useState('inspection')
    const [templateSetting, setTemplateSetting] = useState(null)
    const [pastInspectionsModalOpen, setPastInspectionsModalOpen] =
        useState(false)
    const [pastInspections, setPastInspections] = useState([])
    const [pendingCustomerIds, setPendingCustomerIds] = useState([])
    const dropdownRef = useRef(null)
    const navigate = useNavigate()
    const { errorToast, successToast } = useNotification()
    const { canCloneTemplate, canEditTemplate, canDeleteTemplate } =
        getTemplatePermissions(AuthService.getUser())
    // department role model (opted-in companies only): Viewers / department heads who audit nothing cannot start
    // audits; the approval workflow is configured by admins
    const currentUser = AuthService.getUser()
    const canStartInspection = canStartAuditsByRole(currentUser)
    const approvalWorkflowMenu =
        SHOW_REPORT_APPROVAL_FLOW ||
        (isRoleModelOn(currentUser) && isApprovalAdmin(currentUser))

    useEffect(() => {
        if (modalOpen && customerList && customerList.length > 0) {
            setSelectedCustomer([])
        }
    }, [modalOpen, customerList])

    useEffect(() => {
        const handleClickOutside = event => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setDropdownOpen(false)
            }
        }

        document.addEventListener('mousedown', handleClickOutside)
        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [])

    // TemplateSetting / PastInspections APIs expect E_AuditCustomersTemplate.unique_id
    // (numeric item.Id), not the GUID TemplateId used elsewhere in the app.
    const templateSettingId = item.Id

    const loadTemplateSetting = async () => {
        if (!templateSettingId) {
            setTemplateSetting(null)
            return null
        }

        try {
            const response = await TemplateService.getTemplateSetting(
                templateSettingId,
            )
            setTemplateSetting(response || null)
            return response || null
        } catch (error) {
            // 404 = template not in caller's company, or feature not available
            console.error('Failed to load template setting:', error)
            setTemplateSetting(null)
            return null
        }
    }

    const resolvePastInspectionsOrStart = async (
        customerIds,
        setting = null,
    ) => {
        const customerId = customerIds?.[0]
        const activeSetting = setting || templateSetting

        if (
            !customerId ||
            !templateSettingId ||
            !shouldShowPastInspections(activeSetting)
        ) {
            await startInspection(customerIds)
            return
        }

        try {
            const response = await TemplateService.getPastInspections(
                templateSettingId,
                customerId,
            )
            const items = Array.isArray(response) ? response : []

            // Collection: [] when no completed inspections in the window.
            // Skip empty modal and go straight into the inspection.
            if (items.length === 0) {
                await startInspection(customerIds)
                return
            }

            setPendingCustomerIds(customerIds)
            setPastInspections(items)
            setTemplateSetting(activeSetting)
            setPastInspectionsModalOpen(true)
        } catch (error) {
            console.error('Failed to load past inspections:', error)
            await startInspection(customerIds)
        }
    }

    const continueFromPastInspections = async () => {
        setModalLoading(true)
        try {
            await startInspection(pendingCustomerIds)
            setPastInspectionsModalOpen(false)
            setPendingCustomerIds([])
            setPastInspections([])
        } catch (error) {
            console.error('Error starting inspection:', error)
        } finally {
            setModalLoading(false)
        }
    }

    const closePastInspectionsModal = () => {
        if (modalLoading) return
        setPastInspectionsModalOpen(false)
        setPendingCustomerIds([])
        setPastInspections([])
    }

    const handleDownloadPDF = async () => {
        try {
            setPdfLoading(true)
            // Fetch template details from API
            const templateData = await TemplateService.getTemplateDetails(
                item.TemplateId,
            )

            if (templateData && templateData.Id) {
                // Generate PDF from template data
                generateTemplatePDF(
                    templateData,
                    templateData.TemplateName || 'template',
                )
                successToast('PDF downloaded successfully')
            } else {
                errorToast('Failed to fetch template data')
            }
        } catch (error) {
            console.error('Error downloading PDF:', error)
            errorToast('Failed to download PDF. Please try again.')
        } finally {
            setPdfLoading(false)
            setDropdownOpen(false)
        }
    }

    const handleEdit = () => {
        if (item.IsReadOnly === true) {
            return
        }
        navigate(`/app/templates/edit/${item.TemplateId}`)
        setDropdownOpen(false)
    }

    const handleCloneClick = () => {
        onClone(item)
        setDropdownOpen(false)
    }

    const handleDownloadClick = () => {
        if (item.DownloadPDFLInk) {
            BrowserUtility.downloadFile(
                item.DownloadPDFLInk,
                `${item.TemplateName}.pdf`,
            )
        } else {
            handleDownloadPDF()
        }
        setDropdownOpen(false)
    }

    const handleEmailClick = () => {
        onSendEmail(item)
        setDropdownOpen(false)
    }

    const handleQrStickerClick = () => {
        setModalPurpose('qr')
        setModalOpen(true)
        setDropdownOpen(false)
    }

    const handleDeleteClick = () => {
        setDeleteConfirmOpen(true)
        setDropdownOpen(false)
    }

    const handleDeleteConfirm = () => {
        onRemove()
        setDeleteConfirmOpen(false)
    }

    const handlePreview = async () => {
        try {
            setPreviewLoading(true)

            // Create a real inspection instance from the template
            // const result = await InspectionService.copyInspection({
            //     TemplateId: item.TemplateId,
            //     customerId: 23, // same fixed customer as Start Inspection for WK
            // })
            // const auditId =
            //     result?.AuditTemplateId || result?.AuditId || result?.Id

            // if (!auditId) {
            //     throw new Error(
            //         'No Audit Id returned from CopyInspectionFromTemplate',
            //     )
            // }

            // Open dedicated preview page (separate from regular inspection route)
            navigate(`/app/templates/inspection/preview/${item.TemplateId}`, {
                state: {
                    isReadOnly: true,
                    isPreview: true,
                    autoRemovePreview: true,
                    previewSourceTemplateId: item.TemplateId,
                },
            })
        } catch (error) {
            console.error('Error creating preview inspection:', error)
            errorToast('Failed to create preview inspection. Please try again.')
        } finally {
            setPreviewLoading(false)
            setDropdownOpen(false)
        }
    }

    const handleClosePreview = () => {
        setPreviewOpen(false)
        setPreviewData(null)
        setPreviewAuditId(null)
    }

    const handleSelectClick = async () => {
        const user = AuthService.getUser()
        const companyId = user?.Companies?.[0]?.CompanyId || user?.CompanyId

        setModalLoading(true)
        try {
            const setting = await loadTemplateSetting()

            // For CompanyId === 34930, skip client modal and auto-select customer ID 23
            if (companyId === 34930) {
                if (shouldShowPastInspections(setting)) {
                    await resolvePastInspectionsOrStart([23], setting)
                } else {
                    await startInspection([23])
                }
                return
            }

            setModalPurpose('inspection')
            setModalOpen(true)
        } catch (error) {
            console.error('Error starting inspection:', error)
        } finally {
            setModalLoading(false)
        }
    }

    const handleCustomerModalSubmit = async () => {
        if (modalPurpose === 'qr') {
            setQrCustomerId(selectedCustomer[0] ?? null)
            setModalOpen(false)
            setQrModalOpen(true)
            return
        }

        setModalLoading(true)
        try {
            const setting =
                templateSetting || (await loadTemplateSetting())

            if (shouldShowPastInspections(setting)) {
                // Keep Client/Site modal + loader while PastInspections loads.
                // Empty [] → start inspection directly (no empty Recent modal).
                // Non-empty → open Recent Inspections modal.
                await resolvePastInspectionsOrStart(selectedCustomer, setting)
                setModalOpen(false)
                return
            }

            // Keep Client/Site modal open with loader until inspection is created
            // and navigation starts — closing early leaves the template list with
            // no feedback while CopyInspectionFromTemplate is in flight.
            await startInspection(selectedCustomer)
            setModalOpen(false)
        } catch (error) {
            console.error('Error starting inspection:', error)
        } finally {
            setModalLoading(false)
        }
    }

    return (
        <>
            <FlexBox className="gap-2 align-items-center justify-content-end flex-wrap">
                {item.IsAutoRuleAllow && (
                    <AutoRulesButton
                        templateId={item.TemplateId}
                        templateNumericId={item.Id}
                        templateName={item.TemplateName}
                    />
                )}
                <OutlineButton
                    onClick={handlePreview}
                    disabled={previewLoading}
                    type="button"
                >
                    Preview
                </OutlineButton>
                {canStartInspection && (
                    <AppPrimaryButton
                        onClick={handleSelectClick}
                        disabled={modalLoading}
                        type="button"
                    >
                        {primaryButtonLabel}
                    </AppPrimaryButton>
                )}
                <ActionDropdownContainer ref={dropdownRef}>
                    <Button
                        icon
                        basic
                        aria-label={`More actions for ${item.TemplateName || 'template'}`}
                        aria-haspopup="true"
                        aria-expanded={dropdownOpen}
                        onClick={() => setDropdownOpen(!dropdownOpen)}
                        style={{ padding: '8px', minWidth: 'auto' }}
                    >
                        <DotsThreeVertical size={20} />
                    </Button>
                    {dropdownOpen && (
                        <DropdownMenu>
                            {(canEditTemplate ||
                                canCloneTemplate ||
                                approvalWorkflowMenu) && (
                                <MenuGroupLabel>Manage</MenuGroupLabel>
                            )}
                            {canEditTemplate && (
                                <MenuItem
                                    onClick={handleEdit}
                                    disabled={item.IsReadOnly === true}
                                >
                                    <PencilSimple size={16} />
                                    <span>Edit Template</span>
                                </MenuItem>
                            )}
                            {approvalWorkflowMenu && (
                                <MenuItem
                                    onClick={() => {
                                        navigate(
                                            // numeric template id: the approval-workflow API takes the int id (the GUID 404s)
                                            `/app/templates/${item.Id}/approval-workflow`,
                                            {
                                                state: {
                                                    templateName:
                                                        item.TemplateName,
                                                    templateNumericId: item.Id,
                                                },
                                            },
                                        )
                                        setDropdownOpen(false)
                                    }}
                                >
                                    <CheckCircle size={16} />
                                    <span>Approval Workflow</span>
                                </MenuItem>
                            )}
                            {canEditTemplate && (
                                <MenuItem
                                    onClick={() => {
                                        navigate(
                                            `/app/templates/${item.TemplateId}/reason-presets`,
                                            {
                                                state: {
                                                    templateName:
                                                        item.TemplateName,
                                                    templateNumericId: item.Id,
                                                },
                                            },
                                        )
                                        setDropdownOpen(false)
                                    }}
                                >
                                    <ListChecks size={16} />
                                    <span>Reason presets</span>
                                </MenuItem>
                            )}
                            {canEditTemplate && (
                                <MenuItem
                                    onClick={() => {
                                        // question comments review flow; the API takes the numeric template id
                                        navigate(
                                            `/app/templates/${item.Id}/review-flow`,
                                            {
                                                state: {
                                                    templateName:
                                                        item.TemplateName,
                                                    templateNumericId: item.Id,
                                                },
                                            },
                                        )
                                        setDropdownOpen(false)
                                    }}
                                >
                                    <ChatsCircle size={16} />
                                    <span>Review flow</span>
                                </MenuItem>
                            )}
                            {canCloneTemplate && (
                                <MenuItem onClick={handleCloneClick}>
                                    <Copy size={16} />
                                    <span>Clone Template</span>
                                </MenuItem>
                            )}
                            {(canEditTemplate ||
                                canCloneTemplate ||
                                approvalWorkflowMenu) && <MenuDivider />}
                            <MenuGroupLabel>Share</MenuGroupLabel>
                            <MenuItem
                                onClick={handleDownloadClick}
                                disabled={pdfLoading}
                            >
                                <FilePdf size={16} />
                                <span>Download PDF</span>
                            </MenuItem>
                            <MenuItem onClick={handleEmailClick}>
                                <Envelope size={16} />
                                <span>Email PDF</span>
                            </MenuItem>
                            <MenuItem onClick={handleQrStickerClick}>
                                <QrCode size={16} />
                                <span>Generate QR Sticker</span>
                            </MenuItem>
                            {canDeleteTemplate && item.IsReadOnly !== true && (
                                <MenuDivider />
                            )}
                            {canDeleteTemplate && item.IsReadOnly !== true && (
                                <MenuItem onClick={handleDeleteClick} danger>
                                    <Trash size={16} />
                                    <span>Delete Template</span>
                                </MenuItem>
                            )}
                        </DropdownMenu>
                    )}
                </ActionDropdownContainer>
            </FlexBox>
            <Modal
                key={
                    modalOpen
                        ? customerList
                            ? customerList.length
                            : 0
                        : 'closed'
                }
                open={modalOpen}
                onClose={() => !modalLoading && setModalOpen(false)}
                size="tiny"
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <span>Client / Site</span>
                        <X
                            size={24}
                            style={{
                                cursor: modalLoading
                                    ? 'not-allowed'
                                    : 'pointer',
                            }}
                            onClick={() => !modalLoading && setModalOpen(false)}
                        />
                    </div>
                </Modal.Header>
                <Modal.Content>
                    {(modalLoading || customerLoading) && (
                        <LoaderBar
                            content={
                                modalLoading
                                    ? 'Starting inspection...'
                                    : 'Loading customers...'
                            }
                        />
                    )}
                    {!modalLoading &&
                        !customerLoading &&
                        customerList &&
                        customerList.length > 0 ? (
                        <CustomerList
                            customerList={customerList}
                            selectedCustomer={selectedCustomer}
                            setSelectedCustomer={setSelectedCustomer}
                            onAddNewCustomer={onAddNewCustomer}
                            showAddCustomer={
                                modalPurpose !== 'qr' &&
                                canManageDepartmentsByRole(currentUser)
                            }
                        />
                    ) : null}
                </Modal.Content>
                <Modal.Actions
                    style={{ display: 'flex', gap: '1rem', padding: '1rem' }}
                >
                    <AppPrimaryButton
                        style={{ flex: 1 }}
                        onClick={handleCustomerModalSubmit}
                        disabled={
                            modalLoading ||
                            customerLoading ||
                            !selectedCustomer.length ||
                            !customerList ||
                            customerList.length === 0
                        }
                    >
                        Submit
                    </AppPrimaryButton>
                    <AppButton
                        style={{ flex: 1 }}
                        onClick={() => setModalOpen(false)}
                        disabled={modalLoading}
                    >
                        Close
                    </AppButton>
                </Modal.Actions>
            </Modal>
            <Modal
                open={pastInspectionsModalOpen}
                onClose={closePastInspectionsModal}
                size="small"
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <span>Recent Inspections</span>
                        <X
                            size={24}
                            style={{
                                cursor: modalLoading
                                    ? 'not-allowed'
                                    : 'pointer',
                            }}
                            onClick={closePastInspectionsModal}
                        />
                    </div>
                </Modal.Header>
                <Modal.Content>
                    {modalLoading ? (
                        <LoaderBar content="Starting inspection..." />
                    ) : (
                        <PastInspectionsPanel
                            // Past list is fetched before this modal opens
                            loading={false}
                            items={pastInspections}
                            templateSetting={templateSetting}
                        />
                    )}
                </Modal.Content>
                <Modal.Actions
                    style={{ display: 'flex', gap: '1rem', padding: '1rem' }}
                >
                    <AppPrimaryButton
                        style={{ flex: 1 }}
                        onClick={continueFromPastInspections}
                        disabled={modalLoading}
                    >
                        Continue
                    </AppPrimaryButton>
                    <AppButton
                        style={{ flex: 1 }}
                        onClick={closePastInspectionsModal}
                        disabled={modalLoading}
                    >
                        Close
                    </AppButton>
                </Modal.Actions>
            </Modal>
            <Modal
                open={deleteConfirmOpen}
                onClose={() => setDeleteConfirmOpen(false)}
                size="tiny"
                className="model"
            >
                <Modal.Header>
                    <FlexRowBetween>
                        <span>Delete Template</span>
                        <X
                            className="pointer"
                            size={32}
                            onClick={() => setDeleteConfirmOpen(false)}
                        />
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content>
                    <p>Are you sure you want to delete this template?</p>
                </Modal.Content>
                <Modal.Actions>
                    <AppButton onClick={() => setDeleteConfirmOpen(false)}>
                        Cancel
                    </AppButton>
                    <AppPrimaryButton
                        onClick={handleDeleteConfirm}
                        style={{ backgroundColor: '#dc3545' }}
                    >
                        Delete
                    </AppPrimaryButton>
                </Modal.Actions>
            </Modal>
            <PreviewModal
                open={previewOpen}
                onClose={handleClosePreview}
                size="large"
            >
                <Modal.Header>
                    <FlexRowBetween>
                        <div>
                            <h3 style={{ margin: 0 }}>Template Preview</h3>
                            {previewData && (
                                <p
                                    style={{
                                        margin: '5px 0 0 0',
                                        color: '#666',
                                        fontSize: '0.9rem',
                                    }}
                                >
                                    {previewData.TemplateName}
                                </p>
                            )}
                        </div>
                        <X
                            className="pointer"
                            size={28}
                            onClick={handleClosePreview}
                            style={{ cursor: 'pointer' }}
                        />
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content>
                    {previewLoading ? (
                        <LoaderBar content="Loading preview..." />
                    ) : previewAuditId ? (
                        // WK company: show real inspection in read-only mode
                        <InspectionPreviewContent auditId={previewAuditId} />
                    ) : previewData ? (
                        <div className="modal-scroll-content">
                            {previewData.TemplateDescription && (
                                <div
                                    style={{
                                        marginBottom: '20px',
                                        padding: '15px',
                                        background: '#f8f9fa',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <strong>Description:</strong>{' '}
                                    {previewData.TemplateDescription}
                                </div>
                            )}

                            {previewData.Sections &&
                                previewData.Sections.length > 0 ? (
                                previewData.Sections.map(
                                    (section, sectionIndex) => {
                                        // Get section name from first question or use fallback
                                        const sectionName =
                                            section.Questions &&
                                                section.Questions.length > 0
                                                ? section.Questions[0]
                                                    .SectionName
                                                : section.SectionName ||
                                                `Section ${sectionIndex + 1}`

                                        return (
                                            <div
                                                key={
                                                    section.SectionId ||
                                                    sectionIndex
                                                }
                                                className="section-card"
                                            >
                                                <div className="section-title">
                                                    {sectionName}
                                                </div>
                                                {section.Questions &&
                                                    section.Questions.length > 0 ? (
                                                    section.Questions.map(
                                                        (question, qIndex) => {
                                                            // Get response options based on QuestionResponseId and TemplateResponseType
                                                            const getResponseOptions =
                                                                () => {
                                                                    const questionResponseId =
                                                                        question.QuestionResponseId
                                                                    const questionType =
                                                                        question.QuestionType

                                                                    // If TemplateResponseType is available, use it
                                                                    if (
                                                                        previewData.TemplateResponseType
                                                                    ) {
                                                                        // Single response type (Text, Number, Date, etc.)
                                                                        if (
                                                                            questionType ===
                                                                            TemplateResponseType.Single
                                                                        ) {
                                                                            const singleResponse =
                                                                                previewData.TemplateResponseType.SingleResponses?.find(
                                                                                    r =>
                                                                                        r.Id ===
                                                                                        questionResponseId,
                                                                                )
                                                                            if (
                                                                                singleResponse
                                                                            ) {
                                                                                return {
                                                                                    type: 'single',
                                                                                    label:
                                                                                        singleResponse.DisplayText ||
                                                                                        'Text Answer',
                                                                                    controlType:
                                                                                        singleResponse.Id,
                                                                                }
                                                                            }
                                                                            return {
                                                                                type: 'single',
                                                                                label: 'Text Answer',
                                                                                controlType:
                                                                                    questionResponseId,
                                                                            }
                                                                        }

                                                                        // Multiple response type (Yes/No, Multiple Choice, etc.)
                                                                        if (
                                                                            questionType ===
                                                                            TemplateResponseType.Multiple
                                                                        ) {
                                                                            // Find response group by QuestionResponseId or GroupId
                                                                            const multipleResponse =
                                                                                previewData.TemplateResponseType.MultipleResponse?.find(
                                                                                    r =>
                                                                                        r.Id ===
                                                                                        questionResponseId ||
                                                                                        r.GroupId ===
                                                                                        questionResponseId,
                                                                                )
                                                                            const userMultipleResponse =
                                                                                previewData.TemplateResponseType.UserMultipleResponse?.find(
                                                                                    r =>
                                                                                        r.Id ===
                                                                                        questionResponseId ||
                                                                                        r.GroupId ===
                                                                                        questionResponseId,
                                                                                )

                                                                            const responseGroup =
                                                                                userMultipleResponse ||
                                                                                multipleResponse
                                                                            if (
                                                                                responseGroup
                                                                            ) {
                                                                                // Get all items in the same group, prefer UserMultipleResponse over MultipleResponse
                                                                                const groupId =
                                                                                    responseGroup.GroupId ||
                                                                                    responseGroup.Id
                                                                                const userGroupItems =
                                                                                    (
                                                                                        previewData
                                                                                            .TemplateResponseType
                                                                                            .UserMultipleResponse ||
                                                                                        []
                                                                                    ).filter(
                                                                                        r =>
                                                                                            r.GroupId ===
                                                                                            groupId,
                                                                                    )
                                                                                const multipleGroupItems =
                                                                                    (
                                                                                        previewData
                                                                                            .TemplateResponseType
                                                                                            .MultipleResponse ||
                                                                                        []
                                                                                    ).filter(
                                                                                        r =>
                                                                                            r.GroupId ===
                                                                                            groupId,
                                                                                    )

                                                                                // Use UserMultipleResponse if available, otherwise use MultipleResponse
                                                                                // Deduplicate by Id to avoid showing same option twice
                                                                                const allGroupItems =
                                                                                    userGroupItems.length >
                                                                                        0
                                                                                        ? userGroupItems
                                                                                        : multipleGroupItems
                                                                                const uniqueOptions =
                                                                                    allGroupItems.filter(
                                                                                        (
                                                                                            item,
                                                                                            index,
                                                                                            self,
                                                                                        ) =>
                                                                                            index ===
                                                                                            self.findIndex(
                                                                                                t =>
                                                                                                    t.Id ===
                                                                                                    item.Id,
                                                                                            ),
                                                                                    )

                                                                                return {
                                                                                    type: 'multiple',
                                                                                    options:
                                                                                        uniqueOptions.length >
                                                                                            0
                                                                                            ? uniqueOptions
                                                                                            : [
                                                                                                responseGroup,
                                                                                            ],
                                                                                }
                                                                            }
                                                                        }
                                                                    }

                                                                    // Fallback: Show common response types based on QuestionResponseId
                                                                    // QuestionResponseId = 1 typically means Yes/No
                                                                    if (
                                                                        questionResponseId ===
                                                                        1 &&
                                                                        questionType ===
                                                                        TemplateResponseType.Multiple
                                                                    ) {
                                                                        return {
                                                                            type: 'multiple',
                                                                            options:
                                                                                [
                                                                                    {
                                                                                        Id: 1,
                                                                                        DisplayText:
                                                                                            'Yes',
                                                                                        BackColorCode:
                                                                                            '#6FD193',
                                                                                        ForeColorCode:
                                                                                            '#FFFFFF',
                                                                                    },
                                                                                    {
                                                                                        Id: 2,
                                                                                        DisplayText:
                                                                                            'No',
                                                                                        BackColorCode:
                                                                                            '#E05F57',
                                                                                        ForeColorCode:
                                                                                            '#FFFFFF',
                                                                                    },
                                                                                ],
                                                                        }
                                                                    }

                                                                    // Default: Show question type
                                                                    if (
                                                                        questionType ===
                                                                        TemplateResponseType.Single
                                                                    ) {
                                                                        return {
                                                                            type: 'single',
                                                                            label: 'Text Answer',
                                                                            controlType:
                                                                                questionResponseId,
                                                                        }
                                                                    }

                                                                    return null
                                                                }

                                                            const responseOptions =
                                                                getResponseOptions()
                                                            const questionText =
                                                                question.Question ||
                                                                question.QuestionText ||
                                                                question.Text ||
                                                                'Question'

                                                            return (
                                                                <div
                                                                    key={
                                                                        question.Id ||
                                                                        question.QuestionId ||
                                                                        qIndex
                                                                    }
                                                                    className="question-item"
                                                                >
                                                                    <div className="question-text">
                                                                        <span>
                                                                            {qIndex +
                                                                                1}
                                                                            .{' '}
                                                                        </span>
                                                                        <span
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: questionText,
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="question-meta">
                                                                        {question.IsRequired !==
                                                                            undefined && (
                                                                                <span className="meta-item">
                                                                                    <strong>
                                                                                        Required:
                                                                                    </strong>{' '}
                                                                                    {question.IsRequired
                                                                                        ? 'Yes'
                                                                                        : 'No'}
                                                                                </span>
                                                                            )}
                                                                    </div>
                                                                    {responseOptions && (
                                                                        <div className="response-options">
                                                                            <div className="response-type-label">
                                                                                Response
                                                                                Options:
                                                                            </div>
                                                                            {responseOptions.type ===
                                                                                'single' && (
                                                                                    <div className="response-option-item">
                                                                                        <span
                                                                                            className="response-option-badge"
                                                                                            style={{
                                                                                                background:
                                                                                                    '#e9ecef',
                                                                                                color: '#495057',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                responseOptions.label
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                            {responseOptions.type ===
                                                                                'multiple' &&
                                                                                responseOptions.options && (
                                                                                    <div>
                                                                                        {responseOptions.options.map(
                                                                                            (
                                                                                                option,
                                                                                                optIndex,
                                                                                            ) => (
                                                                                                <div
                                                                                                    key={
                                                                                                        option.Id ||
                                                                                                        optIndex
                                                                                                    }
                                                                                                    className="response-option-item"
                                                                                                >
                                                                                                    <span
                                                                                                        className="response-option-badge"
                                                                                                        style={{
                                                                                                            background:
                                                                                                                option.BackColorCode ||
                                                                                                                '#e9ecef',
                                                                                                            color:
                                                                                                                option.ForeColorCode ||
                                                                                                                '#495057',
                                                                                                        }}
                                                                                                    >
                                                                                                        {option.DisplayText ||
                                                                                                            option.Text ||
                                                                                                            'Option'}
                                                                                                    </span>
                                                                                                </div>
                                                                                            ),
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                    {question.AdditionalInfo && (
                                                                        <div
                                                                            style={{
                                                                                marginTop:
                                                                                    '8px',
                                                                                padding:
                                                                                    '8px',
                                                                                background:
                                                                                    '#f0f0f0',
                                                                                borderRadius:
                                                                                    '4px',
                                                                                fontSize:
                                                                                    '0.875rem',
                                                                            }}
                                                                        >
                                                                            <strong>
                                                                                Guidance:
                                                                            </strong>{' '}
                                                                            {
                                                                                question.AdditionalInfo
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        },
                                                    )
                                                ) : (
                                                    <p
                                                        style={{
                                                            color: '#999',
                                                            fontStyle: 'italic',
                                                        }}
                                                    >
                                                        No questions in this
                                                        section
                                                    </p>
                                                )}
                                            </div>
                                        )
                                    },
                                )
                            ) : (
                                <p
                                    style={{
                                        color: '#999',
                                        textAlign: 'center',
                                        padding: '20px',
                                    }}
                                >
                                    No sections or questions available
                                </p>
                            )}
                        </div>
                    ) : (
                        <p>No preview data available</p>
                    )}
                </Modal.Content>
                <Modal.Actions>
                    <AppPrimaryButton onClick={handleClosePreview}>
                        Close
                    </AppPrimaryButton>
                </Modal.Actions>
            </PreviewModal>
            <QrStickerModal
                open={qrModalOpen}
                onClose={() => {
                    setQrModalOpen(false)
                    setQrCustomerId(null)
                }}
                templateId={item.TemplateId}
                templateName={item.TemplateName}
                customerId={qrCustomerId || null}
            />
        </>
    )
}

const PreviewModal = styled(Modal)`
    .content {
        padding: 2rem !important;
        max-height: 80vh !important;
        overflow-y: auto;
    }

    .modal-scroll-content {
        max-height: 60vh;
        overflow-y: auto;
        padding-right: 10px;

        &::-webkit-scrollbar {
            width: 8px;
        }
        &::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb {
            background: #888;
            border-radius: 4px;
        }
    }

    .section-card {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 15px;
        margin-bottom: 20px;
        border: 1px solid #e0e0e0;
    }

    .section-title {
        font-size: 1.1rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 2px solid #007bff;
    }

    .question-item {
        background: white;
        border-radius: 6px;
        padding: 12px;
        margin-bottom: 10px;
        border-left: 3px solid #007bff;
    }

    .question-text {
        font-weight: 500;
        color: #333;
        margin-bottom: 8px;
    }

    .question-meta {
        display: flex;
        gap: 15px;
        font-size: 0.875rem;
        color: #666;
        flex-wrap: wrap;
    }

    .meta-item {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    .response-options {
        margin-top: 10px;
        padding: 10px;
        background: #f8f9fa;
        border-radius: 6px;
        border-left: 3px solid #007bff;
    }

    .response-option-item {
        display: flex;
        align-items: center;
        padding: 6px 0;
        color: #333;
        font-size: 0.9rem;
    }

    .response-option-badge {
        display: inline-block;
        padding: 4px 10px;
        border-radius: 4px;
        margin-right: 8px;
        font-weight: 500;
        min-width: 60px;
        text-align: center;
        font-size: 0.85rem;
    }

    .response-type-label {
        font-weight: 600;
        color: #666;
        margin-bottom: 8px;
        font-size: 0.875rem;
    }
`

const PublicActionBoxes = ({ addToLibrary, item, processingTemplateId }) => {
    const navigate = useNavigate()
    const [previewOpen, setPreviewOpen] = useState(false)
    const [previewData, setPreviewData] = useState(null)
    const [previewLoading, setPreviewLoading] = useState(false)
    // Only show loading for this specific item
    const isLoading = processingTemplateId === item.TemplateId

    const handleClick = async () => {
        try {
            await addToLibrary(item)
        } catch (e) {
            // Error handling is done in parent component
        }
    }

    const handlePreview = async () => {
        try {
            setPreviewLoading(true)
            navigate(`/app/templates/inspection/preview/${item.TemplateId}`, {
                state: {
                    isReadOnly: true,
                    isPreview: true,
                    previewSourceTemplateId: item.TemplateId,
                    fromPublicLibrary: true,
                },
            })
        } catch (error) {
            console.error('Error loading preview:', error)
        } finally {
            setPreviewLoading(false)
        }
    }

    const handleClosePreview = () => {
        setPreviewOpen(false)
        setPreviewData(null)
    }

    return (
        <>
            <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                <AppPrimaryButton
                    onClick={handlePreview}
                    disabled={previewLoading}
                    style={{ background: '#6c757d' }}
                    size="small"
                >
                    Preview
                </AppPrimaryButton>
                <AddToLibraryButton
                    buttonText="Add to Library"
                    onClick={handleClick}
                    loading={isLoading}
                    disabled={isLoading}
                />
            </div>

            <PreviewModal
                open={previewOpen}
                onClose={handleClosePreview}
                size="large"
            >
                <Modal.Header>
                    <FlexRowBetween>
                        <div>
                            <h3 style={{ margin: 0 }}>Template Preview</h3>
                            {previewData && (
                                <p
                                    style={{
                                        margin: '5px 0 0 0',
                                        color: '#666',
                                        fontSize: '0.9rem',
                                    }}
                                >
                                    {previewData.TemplateName}
                                </p>
                            )}
                        </div>
                        <X
                            className="pointer"
                            size={28}
                            onClick={handleClosePreview}
                            style={{ cursor: 'pointer' }}
                        />
                    </FlexRowBetween>
                </Modal.Header>
                <Modal.Content>
                    {previewLoading ? (
                        <LoaderBar content="Loading template details..." />
                    ) : previewData ? (
                        <div className="modal-scroll-content">
                            {previewData.TemplateDescription && (
                                <div
                                    style={{
                                        marginBottom: '20px',
                                        padding: '15px',
                                        background: '#f8f9fa',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <strong>Description:</strong>{' '}
                                    {previewData.TemplateDescription}
                                </div>
                            )}

                            {previewData.Sections &&
                                previewData.Sections.length > 0 ? (
                                previewData.Sections.map(
                                    (section, sectionIndex) => {
                                        // Get section name from first question or use fallback
                                        const sectionName =
                                            section.Questions &&
                                                section.Questions.length > 0
                                                ? section.Questions[0]
                                                    .SectionName
                                                : section.SectionName ||
                                                `Section ${sectionIndex + 1}`

                                        return (
                                            <div
                                                key={
                                                    section.SectionId ||
                                                    sectionIndex
                                                }
                                                className="section-card"
                                            >
                                                <div className="section-title">
                                                    {sectionName}
                                                </div>
                                                {section.Questions &&
                                                    section.Questions.length > 0 ? (
                                                    section.Questions.map(
                                                        (question, qIndex) => {
                                                            // Get response options based on QuestionResponseId and TemplateResponseType
                                                            const getResponseOptions =
                                                                () => {
                                                                    const questionResponseId =
                                                                        question.QuestionResponseId
                                                                    const questionType =
                                                                        question.QuestionType

                                                                    // If TemplateResponseType is available, use it
                                                                    if (
                                                                        previewData.TemplateResponseType
                                                                    ) {
                                                                        // Single response type (Text, Number, Date, etc.)
                                                                        if (
                                                                            questionType ===
                                                                            TemplateResponseType.Single
                                                                        ) {
                                                                            const singleResponse =
                                                                                previewData.TemplateResponseType.SingleResponses?.find(
                                                                                    r =>
                                                                                        r.Id ===
                                                                                        questionResponseId,
                                                                                )
                                                                            if (
                                                                                singleResponse
                                                                            ) {
                                                                                return {
                                                                                    type: 'single',
                                                                                    label:
                                                                                        singleResponse.DisplayText ||
                                                                                        'Text Answer',
                                                                                    controlType:
                                                                                        singleResponse.Id,
                                                                                }
                                                                            }
                                                                            return {
                                                                                type: 'single',
                                                                                label: 'Text Answer',
                                                                                controlType:
                                                                                    questionResponseId,
                                                                            }
                                                                        }

                                                                        // Multiple response type (Yes/No, Multiple Choice, etc.)
                                                                        if (
                                                                            questionType ===
                                                                            TemplateResponseType.Multiple
                                                                        ) {
                                                                            // Find response group by QuestionResponseId or GroupId
                                                                            const multipleResponse =
                                                                                previewData.TemplateResponseType.MultipleResponse?.find(
                                                                                    r =>
                                                                                        r.Id ===
                                                                                        questionResponseId ||
                                                                                        r.GroupId ===
                                                                                        questionResponseId,
                                                                                )
                                                                            const userMultipleResponse =
                                                                                previewData.TemplateResponseType.UserMultipleResponse?.find(
                                                                                    r =>
                                                                                        r.Id ===
                                                                                        questionResponseId ||
                                                                                        r.GroupId ===
                                                                                        questionResponseId,
                                                                                )

                                                                            const responseGroup =
                                                                                userMultipleResponse ||
                                                                                multipleResponse
                                                                            if (
                                                                                responseGroup
                                                                            ) {
                                                                                // Get all items in the same group, prefer UserMultipleResponse over MultipleResponse
                                                                                const groupId =
                                                                                    responseGroup.GroupId ||
                                                                                    responseGroup.Id
                                                                                const userGroupItems =
                                                                                    (
                                                                                        previewData
                                                                                            .TemplateResponseType
                                                                                            .UserMultipleResponse ||
                                                                                        []
                                                                                    ).filter(
                                                                                        r =>
                                                                                            r.GroupId ===
                                                                                            groupId,
                                                                                    )
                                                                                const multipleGroupItems =
                                                                                    (
                                                                                        previewData
                                                                                            .TemplateResponseType
                                                                                            .MultipleResponse ||
                                                                                        []
                                                                                    ).filter(
                                                                                        r =>
                                                                                            r.GroupId ===
                                                                                            groupId,
                                                                                    )

                                                                                // Use UserMultipleResponse if available, otherwise use MultipleResponse
                                                                                // Deduplicate by Id to avoid showing same option twice
                                                                                const allGroupItems =
                                                                                    userGroupItems.length >
                                                                                        0
                                                                                        ? userGroupItems
                                                                                        : multipleGroupItems
                                                                                const uniqueOptions =
                                                                                    allGroupItems.filter(
                                                                                        (
                                                                                            item,
                                                                                            index,
                                                                                            self,
                                                                                        ) =>
                                                                                            index ===
                                                                                            self.findIndex(
                                                                                                t =>
                                                                                                    t.Id ===
                                                                                                    item.Id,
                                                                                            ),
                                                                                    )

                                                                                return {
                                                                                    type: 'multiple',
                                                                                    options:
                                                                                        uniqueOptions.length >
                                                                                            0
                                                                                            ? uniqueOptions
                                                                                            : [
                                                                                                responseGroup,
                                                                                            ],
                                                                                }
                                                                            }
                                                                        }
                                                                    }

                                                                    // Fallback: Show common response types based on QuestionResponseId
                                                                    // QuestionResponseId = 1 typically means Yes/No
                                                                    if (
                                                                        questionResponseId ===
                                                                        1 &&
                                                                        questionType ===
                                                                        TemplateResponseType.Multiple
                                                                    ) {
                                                                        return {
                                                                            type: 'multiple',
                                                                            options:
                                                                                [
                                                                                    {
                                                                                        Id: 1,
                                                                                        DisplayText:
                                                                                            'Yes',
                                                                                        BackColorCode:
                                                                                            '#6FD193',
                                                                                        ForeColorCode:
                                                                                            '#FFFFFF',
                                                                                    },
                                                                                    {
                                                                                        Id: 2,
                                                                                        DisplayText:
                                                                                            'No',
                                                                                        BackColorCode:
                                                                                            '#E05F57',
                                                                                        ForeColorCode:
                                                                                            '#FFFFFF',
                                                                                    },
                                                                                ],
                                                                        }
                                                                    }

                                                                    // Default: Show question type
                                                                    if (
                                                                        questionType ===
                                                                        TemplateResponseType.Single
                                                                    ) {
                                                                        return {
                                                                            type: 'single',
                                                                            label: 'Text Answer',
                                                                            controlType:
                                                                                questionResponseId,
                                                                        }
                                                                    }

                                                                    return null
                                                                }

                                                            const responseOptions =
                                                                getResponseOptions()
                                                            const questionText =
                                                                question.Question ||
                                                                question.QuestionText ||
                                                                question.Text ||
                                                                'Question'

                                                            return (
                                                                <div
                                                                    key={
                                                                        question.Id ||
                                                                        question.QuestionId ||
                                                                        qIndex
                                                                    }
                                                                    className="question-item"
                                                                >
                                                                    <div className="question-text">
                                                                        <span>
                                                                            {qIndex +
                                                                                1}
                                                                            .{' '}
                                                                        </span>
                                                                        <span
                                                                            dangerouslySetInnerHTML={{
                                                                                __html: questionText,
                                                                            }}
                                                                        />
                                                                    </div>
                                                                    <div className="question-meta">
                                                                        {question.IsRequired !==
                                                                            undefined && (
                                                                                <span className="meta-item">
                                                                                    <strong>
                                                                                        Required:
                                                                                    </strong>{' '}
                                                                                    {question.IsRequired
                                                                                        ? 'Yes'
                                                                                        : 'No'}
                                                                                </span>
                                                                            )}
                                                                    </div>
                                                                    {responseOptions && (
                                                                        <div className="response-options">
                                                                            <div className="response-type-label">
                                                                                Response
                                                                                Options:
                                                                            </div>
                                                                            {responseOptions.type ===
                                                                                'single' && (
                                                                                    <div className="response-option-item">
                                                                                        <span
                                                                                            className="response-option-badge"
                                                                                            style={{
                                                                                                background:
                                                                                                    '#e9ecef',
                                                                                                color: '#495057',
                                                                                            }}
                                                                                        >
                                                                                            {
                                                                                                responseOptions.label
                                                                                            }
                                                                                        </span>
                                                                                    </div>
                                                                                )}
                                                                            {responseOptions.type ===
                                                                                'multiple' &&
                                                                                responseOptions.options && (
                                                                                    <div>
                                                                                        {responseOptions.options.map(
                                                                                            (
                                                                                                option,
                                                                                                optIndex,
                                                                                            ) => (
                                                                                                <div
                                                                                                    key={
                                                                                                        option.Id ||
                                                                                                        optIndex
                                                                                                    }
                                                                                                    className="response-option-item"
                                                                                                >
                                                                                                    <span
                                                                                                        className="response-option-badge"
                                                                                                        style={{
                                                                                                            background:
                                                                                                                option.BackColorCode ||
                                                                                                                '#e9ecef',
                                                                                                            color:
                                                                                                                option.ForeColorCode ||
                                                                                                                '#495057',
                                                                                                        }}
                                                                                                    >
                                                                                                        {option.DisplayText ||
                                                                                                            option.Text ||
                                                                                                            'Option'}
                                                                                                    </span>
                                                                                                </div>
                                                                                            ),
                                                                                        )}
                                                                                    </div>
                                                                                )}
                                                                        </div>
                                                                    )}
                                                                    {question.AdditionalInfo && (
                                                                        <div
                                                                            style={{
                                                                                marginTop:
                                                                                    '8px',
                                                                                padding:
                                                                                    '8px',
                                                                                background:
                                                                                    '#f0f0f0',
                                                                                borderRadius:
                                                                                    '4px',
                                                                                fontSize:
                                                                                    '0.875rem',
                                                                            }}
                                                                        >
                                                                            <strong>
                                                                                Guidance:
                                                                            </strong>{' '}
                                                                            {
                                                                                question.AdditionalInfo
                                                                            }
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )
                                                        },
                                                    )
                                                ) : (
                                                    <p
                                                        style={{
                                                            color: '#999',
                                                            fontStyle: 'italic',
                                                        }}
                                                    >
                                                        No questions in this
                                                        section
                                                    </p>
                                                )}
                                            </div>
                                        )
                                    },
                                )
                            ) : (
                                <p
                                    style={{
                                        color: '#999',
                                        textAlign: 'center',
                                        padding: '20px',
                                    }}
                                >
                                    No sections or questions available
                                </p>
                            )}
                        </div>
                    ) : (
                        <p>No preview data available</p>
                    )}
                </Modal.Content>
                <Modal.Actions>
                    <AppPrimaryButton onClick={handleClosePreview}>
                        Close
                    </AppPrimaryButton>
                </Modal.Actions>
            </PreviewModal>
        </>
    )
}

const TEMPLATE_SORT_OPTIONS = [
    {
        key: 'name',
        group: 'Template Name',
        label: 'A to Z',
        short: 'Template Name · A–Z',
        caret: 'up',
    },
    {
        key: 'name_desc',
        group: 'Template Name',
        label: 'Z to A',
        short: 'Template Name · Z–A',
        caret: 'down',
    },
    {
        key: 'created_desc',
        group: 'Created date',
        label: 'Newest first',
        short: 'Date · Newest',
        caret: 'down',
    },
    {
        key: 'created_asc',
        group: 'Created date',
        label: 'Oldest first',
        short: 'Date · Oldest',
        caret: 'up',
    },
]

const TEMPLATE_SORT_GROUPS = ['Template Name', 'Created date']

const SortTrigger = styled.button`
    background: transparent;
    border: 0;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    color: inherit;
    font-weight: 700;
    font-size: inherit;
    font-family: inherit;
    line-height: 1.2;

    &:hover {
        color: ${({ theme }) => theme.colors?.primary || '#2185d0'};
    }
`

const SortTriggerText = styled.span`
    display: flex;
    flex-direction: column;
    align-items: center;
`

const SortHint = styled.span`
    margin-top: 2px;
    font-size: 11px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors?.primary || '#2185d0'};
    white-space: nowrap;
`

const SortMenu = styled.div`
    position: fixed;
    z-index: 2000;
    width: 248px;
    background: #fff;
    border: 1px solid #e6e8eb;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.16);
    padding: 6px 0;
`

const SortGroupLabel = styled.div`
    padding: 8px 14px 2px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: #6b7280;
`

const SortOption = styled.button`
    width: 100%;
    border: 0;
    background: ${({ $active }) => ($active ? '#eef5ff' : 'transparent')};
    color: ${({ $active, theme }) =>
        $active ? theme.colors?.primary || '#2185d0' : '#1f2937'};
    text-align: left;
    padding: 8px 14px;
    cursor: pointer;
    font-size: 14px;
    font-weight: ${({ $active }) => ($active ? 700 : 500)};
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;

    &:hover {
        background: #f5f7fb;
    }
`

const SortClear = styled.button`
    width: calc(100% - 16px);
    margin: 6px 8px 4px;
    border: 0;
    border-top: 1px solid #eef0f3;
    background: transparent;
    color: #6b7280;
    text-align: left;
    padding: 10px 6px 6px;
    cursor: pointer;
    font-size: 13px;

    &:hover {
        color: #111827;
    }
`

const TemplateSortControl = ({ sortKey, onChange, triggerLabel }) => {
    const [open, setOpen] = useState(false)
    const [coords, setCoords] = useState({ top: 0, left: 0 })
    const triggerRef = useRef(null)
    const menuRef = useRef(null)
    const active = TEMPLATE_SORT_OPTIONS.find(option => option.key === sortKey)

    const updatePosition = () => {
        const rect = triggerRef.current?.getBoundingClientRect()
        if (!rect) return
        const menuWidth = 248
        const left = Math.min(
            Math.max(8, rect.left),
            window.innerWidth - menuWidth - 8,
        )
        setCoords({ top: rect.bottom + 6, left })
    }

    useEffect(() => {
        if (!open) return undefined

        updatePosition()

        const onPointer = event => {
            if (
                triggerRef.current?.contains(event.target) ||
                menuRef.current?.contains(event.target)
            ) {
                return
            }
            setOpen(false)
        }
        const onKey = event => {
            if (event.key === 'Escape') setOpen(false)
        }

        window.addEventListener('mousedown', onPointer)
        window.addEventListener('resize', updatePosition)
        window.addEventListener('scroll', updatePosition, true)
        window.addEventListener('keydown', onKey)
        return () => {
            window.removeEventListener('mousedown', onPointer)
            window.removeEventListener('resize', updatePosition)
            window.removeEventListener('scroll', updatePosition, true)
            window.removeEventListener('keydown', onKey)
        }
    }, [open])

    return (
        <>
            <SortTrigger
                type="button"
                ref={triggerRef}
                aria-haspopup="menu"
                aria-expanded={open}
                onClick={event => {
                    event.stopPropagation()
                    setOpen(current => !current)
                }}
            >
                <SortTriggerText>
                    <span>{triggerLabel}</span>
                    {active && <SortHint>{active.short}</SortHint>}
                </SortTriggerText>
                <CaretDown size={14} weight="bold" />
            </SortTrigger>
            {open &&
                createPortal(
                    <SortMenu
                        ref={menuRef}
                        role="menu"
                        style={{ top: coords.top, left: coords.left }}
                    >
                        {TEMPLATE_SORT_GROUPS.map(group => (
                            <div key={group}>
                                <SortGroupLabel>{group}</SortGroupLabel>
                                {TEMPLATE_SORT_OPTIONS.filter(
                                    option => option.group === group,
                                ).map(option => {
                                    const selected = sortKey === option.key
                                    const Icon =
                                        option.caret === 'up' ? CaretUp : CaretDown
                                    return (
                                        <SortOption
                                            key={option.key}
                                            type="button"
                                            role="menuitemradio"
                                            aria-checked={selected}
                                            $active={selected}
                                            onClick={() => {
                                                onChange(option.key)
                                                setOpen(false)
                                            }}
                                        >
                                            <span>{option.label}</span>
                                            {selected && <Icon size={14} />}
                                        </SortOption>
                                    )
                                })}
                            </div>
                        ))}
                        {sortKey && sortKey !== 'name' && (
                            <SortClear
                                type="button"
                                onClick={() => {
                                    onChange('name')
                                    setOpen(false)
                                }}
                            >
                                Clear sort
                            </SortClear>
                        )}
                    </SortMenu>,
                    document.body,
                )}
        </>
    )
}

export const TemplateList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    onRemove,
    startInspection,
    customerList,
    customerLoading,
    // eslint-disable-next-line no-unused-vars
    onSendEmail,
    refreshCustomerList,
    primaryButtonLabel = 'Start Inspection',
    templateNameColors,
    sortBy = 'name',
    onSortChange,
}) => {
    const { successToast } = useNotification()
    const { refetchUsage } = useSubscriptionUsage()
    const isMobile = useTabletAndBelowMediaQuery()
    const sortKey = sortBy || 'name'
    const handleSortChange = value => {
        if (onSortChange) onSortChange(value || 'name')
    }
    const [isModalOpen, setModalOpen] = useState(false)
    const [selectedItem, setSelectedItem] = useState(null)
    const [selectedGroups, setSelectedGroups] = useState([])
    const [cloneModalOpen, setCloneModalOpen] = useState(false)
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const [newCustomerModalOpen, setNewCustomerModalOpen] = useState(false)

    // Add state for the Send Email modal
    const [sendEmailModalOpen, setSendEmailModalOpen] = useState(false)

    const handleSetCapa = async item => {
        setSelectedItem(item)
        if (item?.TemplateId) {
            try {
                const response =
                    await GroupService.getTeamGroupCapaByTemplateId(
                        item.TemplateId,
                    )
                if (response?.Records && Array.isArray(response.Records)) {
                    setSelectedGroups(response.Records)
                } else {
                    setSelectedGroups([])
                }
            } catch (error) {
                console.error('Failed to fetch selected CAPA groups:', error)
                setSelectedGroups([])
            }
        }
        setModalOpen(true)
    }

    const closeModal = () => {
        setModalOpen(false)
        setSelectedItem(null)
        setSelectedGroups([])
    }

    // Add handler for the Send Email button
    const handleSendEmail = template => {
        setSelectedTemplate(template)
        setSendEmailModalOpen(true)
    }

    const handleClone = template => {
        setSelectedTemplate(template)
        setCloneModalOpen(true)
    }

    const handleCloneSubmit = async (templateId, newName, createdBy) => {
        try {
            await TemplateService.cloneTemplate({
                TemplateId: templateId,
                NewTemplateName: newName,
                CreatedBy: createdBy,
            })
            successToast('Template cloned successfully')
            refetchUsage()
            // Refresh the template list
            pageChanged(1)
        } catch (error) {
            const data = error?.error || {}
            const code = getPlanLimitCode(data)
            if (!(error?.status === 403 && isPlanLimitErrorCode(code))) {
                console.error('Failed to clone template:', error)
            }
        }
    }

    const handleAddNewCustomer = () => {
        setNewCustomerModalOpen(true)
    }

    const handleCustomerAdded = async () => {
        if (refreshCustomerList) {
            await refreshCustomerList()
        }
    }

    const columns = useMemo(
        () => [
            {
                title: (
                    <TemplateSortControl
                        sortKey={sortKey}
                        onChange={handleSortChange}
                        triggerLabel="Template name"
                    />
                ),
                textAlign: 'left',
                render: item => (
                    <TemplateNameCell item={item} colors={templateNameColors} />
                ),
            },
            {
                title: 'Visibility',
                textAlign: 'left',
                width: '120px',
                render: item =>
                    item.IsPublic ? (
                        <StatusPill style={{ background: '#e6f5ec', color: '#17803f' }}>
                            Public
                        </StatusPill>
                    ) : (
                        <StatusPill style={{ background: '#eef0f4', color: '#4a5263' }}>
                            Private
                        </StatusPill>
                    ),
            },
            {
                title: 'Default',
                textAlign: 'left',
                width: '110px',
                render: item =>
                    item.IsDefault ? (
                        <StatusPill style={{ background: '#e8edfb', color: '#1e44b8' }}>
                            Default
                        </StatusPill>
                    ) : (
                        <span style={{ color: '#5b6475' }}>
                            <span aria-hidden="true">—</span>
                            <span className="visually-hidden">Not default</span>
                        </span>
                    ),
            },
            // Hiding "Is Capa" column
            {
                title: 'Actions',
                key: 'Actions',
                textAlign: 'right',
                render: item => (
                    <FlexBox className="justify-content-end">
                        <ActionBoxes
                            key={item.TemplateId}
                            isMobile={isMobile}
                            startInspection={list =>
                                startInspection(item, list)
                            }
                            item={item}
                            customerList={customerList}
                            customerLoading={customerLoading}
                            onRemove={() => onRemove(item)}
                            handleSetCapa={() => handleSetCapa(item)}
                            onSendEmail={handleSendEmail}
                            onClone={handleClone}
                            onAddNewCustomer={handleAddNewCustomer}
                            primaryButtonLabel={primaryButtonLabel}
                        />
                    </FlexBox>
                ),
            },
        ],
        [
            data,
            totalCount,
            filter,
            isMobile,
            customerList,
            customerLoading,
            templateNameColors,
            sortKey,
            onSortChange,
        ],
    )

    return (
        <>
            {isMobile && (
                <div className="d-flex justify-content-end mb-2">
                    <TemplateSortControl
                        sortKey={sortKey}
                        onChange={handleSortChange}
                        triggerLabel="Sort by"
                    />
                </div>
            )}
            <TemplateTableShell>
            <AppTable
                data={data}
                columns={columns}
                pageChanged={pageChanged}
                filter={filter}
                totalCount={totalCount}
                mobileCard={
                    <TemplateCard
                        onRemove={onRemove}
                        startInspection={startInspection}
                        customerList={customerList}
                        customerLoading={customerLoading}
                        handleSetCapa={handleSetCapa}
                        onSendEmail={handleSendEmail}
                        onClone={handleClone}
                        onAddNewCustomer={handleAddNewCustomer}
                        primaryButtonLabel={primaryButtonLabel}
                        templateNameColors={templateNameColors}
                    />
                }
            />
            </TemplateTableShell>
            <CapaModal
                isOpen={isModalOpen}
                onClose={closeModal}
                selectedItem={selectedItem}
                selectedGroups={selectedGroups}
            />

            {/* Add the Send Email modal */}
            {sendEmailModalOpen && selectedTemplate && (
                <SendEmailModal
                    open={sendEmailModalOpen}
                    onClose={() => setSendEmailModalOpen(false)}
                    template={selectedTemplate}
                />
            )}
            {cloneModalOpen && selectedTemplate && (
                <CloneTemplateModal
                    open={cloneModalOpen}
                    onClose={() => setCloneModalOpen(false)}
                    onSubmit={handleCloneSubmit}
                    template={selectedTemplate}
                />
            )}
            <NewCustomerModal
                open={newCustomerModalOpen}
                onClose={() => setNewCustomerModalOpen(false)}
                onCustomerAdded={handleCustomerAdded}
            />
        </>
    )
}

export const PublicTemplateList = ({
    data,
    filter,
    pageChanged,
    totalCount,
    addToLibrary,
    processingTemplateId,
}) => {
    const isMobile = useTabletAndBelowMediaQuery()
    const processedData = useMemo(() => {
        return data.map(item => ({
            ...item,
            CombinedTemplateName: (
                <div>
                    <strong>{item.TemplateName}</strong>{' '}
                    <span
                        style={{
                            backgroundColor: 'teal',
                            color: 'White',
                            padding: '2px 6px',
                            borderRadius: '4px',
                            fontSize: '12px',
                            display: 'inline-block',
                            marginLeft: '8px', // Adds spacing between TemplateName and Category
                        }}
                    >
                        {item.Category || 'No Category'}
                    </span>
                </div>
            ),
            TemplateDescriptionRender: (
                <TemplateDescription description={item.TemplateDescription} />
            ),
        }))
    }, [data])

    // Define columns
    const columns = useMemo(
        () => [
            {
                title: 'Template Name',
                key: 'CombinedTemplateName',
            },
            {
                title: 'Template Description',
                key: 'TemplateDescriptionRender',
                width: '38%',
            },
            {
                title: 'Actions',
                key: 'Actions',
                render: item => (
                    <FlexBox className="justify-content-center">
                        <PublicActionBoxes
                            isMobile={isMobile}
                            item={item}
                            addToLibrary={addToLibrary}
                            processingTemplateId={processingTemplateId}
                        />
                    </FlexBox>
                ),
            },
        ],
        [isMobile, addToLibrary, processingTemplateId],
    )

    return (
        <AppTable
            className="table-cell"
            data={processedData} // Pass the processed data
            columns={columns}
            pageChanged={pageChanged}
            filter={filter}
            totalCount={totalCount}
            mobileCard={
                <PublicTemplateCard
                    addToLibrary={addToLibrary}
                    processingTemplateId={processingTemplateId}
                />
            }
        />
    )
}

export const TemplateListWithCheckBox = ({
    data,
    filter,
    pageChanged,
    totalCount,
    onQuestionSelect,
    removeTemplate,
    copyTemplates,
    addTemplates,
}) => {
    return (
        <>
            <Table compact celled>
                <Table.Header>
                    <Table.Row active>
                        <Table.HeaderCell textAlign="center">
                            {' '}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={8} textAlign="center">
                            TemplateName
                        </Table.HeaderCell>
                        <DesktopMode>
                            <Table.HeaderCell textAlign="center">
                                Is Public
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">
                                Is Default
                            </Table.HeaderCell>
                        </DesktopMode>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {data.map(item => (
                        <React.Fragment key={item.Id}>
                            <RowCheckBox
                                item={item}
                                onQuestionSelect={onQuestionSelect}
                                removeTemplate={removeTemplate}
                                copyTemplate={copyTemplates?.[item.Id]}
                                addTemplates={addTemplates}
                            />
                        </React.Fragment>
                    ))}
                </Table.Body>
            </Table>
            <div className="w-100 justify-content-end d-flex mt-2">
                <PaginationComponent
                    activePage={filter.PageNumber}
                    pageChanged={pageChanged}
                    pageSize={filter.PageSize}
                    totalCount={totalCount}
                />
            </div>
        </>
    )
}
export const PublicTemplateListWithCheckBox = ({
    data,
    filter,
    pageChanged,
    totalCount,
    onQuestionSelect,
    removeTemplate,
    copyTemplates,
    addTemplates,
}) => {
    return (
        <>
            <Table compact celled>
                <Table.Header>
                    <Table.Row active>
                        <Table.HeaderCell textAlign="center">
                            {' '}
                        </Table.HeaderCell>
                        <Table.HeaderCell width={8} textAlign="center">
                            TemplateName
                        </Table.HeaderCell>
                        <DesktopMode>
                            <Table.HeaderCell textAlign="center">
                                Is Public
                            </Table.HeaderCell>
                            <Table.HeaderCell textAlign="center">
                                Is Default
                            </Table.HeaderCell>
                        </DesktopMode>
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {data.map(item => (
                        <React.Fragment key={item.Id}>
                            <PublicRowCheckBox
                                item={item}
                                onQuestionSelect={onQuestionSelect}
                                removeTemplate={removeTemplate}
                                copyTemplate={copyTemplates?.[item.Id]}
                                addTemplates={addTemplates}
                            />
                        </React.Fragment>
                    ))}
                </Table.Body>
            </Table>
            <div className="w-100 justify-content-end d-flex mt-2">
                <PaginationComponent
                    activePage={filter.PageNumber}
                    pageChanged={pageChanged}
                    pageSize={filter.PageSize}
                    totalCount={totalCount}
                />
            </div>
        </>
    )
}
